export enum PersonContactEntityEnum {
    SALE = 'SALE',
    OPPORTUNITY = 'OPPORTUNITY',
    PERSON_CONTACT = 'PERSON_CONTACT',
}
